import { updateUser } from "@/services/api";
import { useCurrentUser } from "@/services/hooks";
import {
  Box,
  Skeleton,
  TextField,
  Autocomplete,
  Typography,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";
import AlertSnackbar from "@/components/AlertSnackbar";
import { ForumOutlined, Instagram } from "@mui/icons-material";

export default function EditCommunity() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();

  const [value, setValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const metaKey = "community";

  // Update state when currentUser data is loaded
  useEffect(() => {
    if (currentUser) {
      setValue(currentUser.meta?.[metaKey] || "On");
    }
  }, [currentUser]);

  const mutation = useMutation({
    mutationFn: () => updateUser(null, { [metaKey]: value }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const debouncedSave = useCallback(
    debounce((newValue) => {
      mutation.mutate();
    }, 1000),
    []
  );

  const handleChange = (e, newValue) => {
    console.log(newValue);
    setValue(newValue);
    debouncedSave(newValue);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={56}
        width="100%"
        sx={{ my: 2, borderRadius: "25px" }}
      />
    );
  }

  return (
    <Box>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      <Autocomplete
        value={value}
        onChange={handleChange}
        options={["On", "Off"]}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <ForumOutlined sx={{ p: 0 }} />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Community Threads
                </Typography>
              </Box>
            }
            helperText="Allow fans to create forum topics."
            disabled={mutation.isPending}
          />
        )}
      />
    </Box>
  );
}
